import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { BrowserRouter } from 'react-router-dom'; // React Router
import { Provider } from 'react-redux'; // Importer le Provider de react-redux
import store from './store/store';
import "bootstrap/dist/css/bootstrap.min.css";
import './index.scss';
import { HelmetProvider } from 'react-helmet-async'; // Importer HelmetProvider
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";

// Créer une racine pour l'application
const root = ReactDOM.createRoot(document.getElementById('root'));

// Rendre l'application en utilisant createRoot
root.render(
  <BrowserRouter>
    <Provider store={store}> {/* Envelopper l'application dans le Provider et passer le store */}
      <HelmetProvider> {/* Ajouter HelmetProvider pour gérer le SEO dynamique */}
        <App />
      </HelmetProvider>
    </Provider>
  </BrowserRouter>
);
